"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContextualHelp = exports.resourceIdToUrl = void 0;
var _react = require("react");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var host = 'https://support.hpe.com';
var docDisplay = "".concat(host, "/hpesc/public/docDisplay");
var baseUrl = '/hpesc/public/api/document/pages';
var renderLatest = "".concat(baseUrl, "/renderLatest");
var resourceIdToUrl = exports.resourceIdToUrl = function resourceIdToUrl(resourceId, locale, proxy) {
  var appLocale = locale === null || locale === void 0 ? void 0 : locale.replaceAll('-', '_');
  return "".concat(proxy || host).concat(renderLatest, "?resourceId=").concat(resourceId, "&locale=").concat(appLocale);
};
var resourceIdToDetailUrl = function resourceIdToDetailUrl(resourceId, locale, proxy) {
  var appLocale = locale === null || locale === void 0 ? void 0 : locale.replaceAll('-', '_');
  return "".concat(proxy || host).concat(baseUrl, "?resourceId=").concat(resourceId, "&locale=").concat(appLocale);
};
var parseUrl = function parseUrl(url) {
  var _urlParts$, _urlParts$0$match;
  var urlParts = url.split('?');
  var params = (_urlParts$ = urlParts[1]) === null || _urlParts$ === void 0 ? void 0 : _urlParts$.split('&');
  var paramMap = {};
  params.forEach(function (p) {
    var nameValue = p.split('=');
    paramMap[nameValue[0]] = nameValue[1];
  });
  var docId = (_urlParts$0$match = urlParts[0].match(/\/document\/([a-zA-Z0-9_-]+)\/render$/)) === null || _urlParts$0$match === void 0 ? void 0 : _urlParts$0$match[1];
  return _objectSpread({
    docId: docId
  }, paramMap);
};
var fetchResource = function fetchResource(url) {
  return fetch(url).then(function (response) {
    return response.ok ? response.json() : response.statusText;
  }).then(function (data) {
    return data === null || data === void 0 ? void 0 : data.page_html;
  });
};
var fetchDetail = function fetchDetail(url) {
  return fetch(url).then(function (response) {
    return response.ok ? response.json() : response.statusText;
  }).then(function (data) {
    return data;
  });
};
var isSingleTopic = function isSingleTopic(data) {
  var _sections$;
  var div = document.createElement('div');
  div.innerHTML = data;
  var sections = div.getElementsByClassName('section');
  var examples = div.getElementsByClassName('example');
  return sections.length === 1 && examples.length < 1 ? (_sections$ = sections[0]) === null || _sections$ === void 0 || (_sections$ = _sections$.id) === null || _sections$ === void 0 || (_sections$ = _sections$.split('__')[1]) === null || _sections$ === void 0 ? void 0 : _sections$.toLowerCase() : undefined;
};
var useContextualHelp = exports.useContextualHelp = function useContextualHelp(locale, proxy, viewTopicPrefix) {
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    topicsId = _useState2[0],
    setTopicsId = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    topics = _useState4[0],
    setTopics = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = _slicedToArray(_useState5, 2),
    activeTopicContent = _useState6[0],
    setActiveTopicContent = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    activeTopicUrl = _useState8[0],
    setActiveTopicUrl = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = _slicedToArray(_useState11, 2),
    loading = _useState12[0],
    setLoading = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    activeTopicUrls = _useState14[0],
    setActiveTopicUrls = _useState14[1];
  var setActiveTopicId = (0, _react.useCallback)(function (resourceId) {
    if (resourceId) {
      setActiveTopicUrls([resourceIdToUrl(resourceId, locale, proxy)]);
    } else if (activeTopicUrls.length > 0) {
      setActiveTopicUrls(function (prev) {
        return prev.slice(0, prev.length - 1);
      });
    }
  }, [locale, activeTopicUrls, proxy]);
  var addTopicUrl = (0, _react.useCallback)(function (url, root) {
    var processedUrl = proxy ? url.replace('https://support.hpe.com', proxy) : url;
    setActiveTopicUrls(function (prev) {
      return root ? [processedUrl] : [].concat(_toConsumableArray(prev), [processedUrl]);
    });
  }, [proxy]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  (0, _react.useEffect)(function () {
    setError(undefined);
    setTopics(undefined);
    setActiveTopicUrls([]);
    setActiveTopicContent(undefined);
    if (topicsId) {
      setLoading(true);
      fetchResource(resourceIdToUrl(topicsId, locale, proxy)).then(function (data) {
        var id = isSingleTopic(data);
        if (id) {
          setActiveTopicId(id);
        } else {
          setTopics(data);
          setLoading(false);
        }
      })["catch"](function (e) {
        setLoading(false);
        setError(e);
      });
    }
  }, [topicsId, locale, proxy]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  (0, _react.useEffect)(function () {
    setActiveTopicContent(undefined);
    setActiveTopicUrl(undefined);
    if (activeTopicUrls.length > 0) {
      setLoading(true);
      setError(undefined);
      fetchResource(activeTopicUrls[activeTopicUrls.length - 1]).then(function (data) {
        setActiveTopicContent(data);
        setLoading(false);
      })["catch"](function (e) {
        setLoading(false);
        setError(e);
      });
    }
  }, [activeTopicUrls, locale]);
  (0, _react.useEffect)(function () {
    if (activeTopicUrls.length > 0) {
      var url = activeTopicUrls[activeTopicUrls.length - 1];
      var urlDetails = parseUrl(url);
      if (urlDetails.resourceId) {
        fetchDetail(resourceIdToDetailUrl("".concat(viewTopicPrefix || '').concat(urlDetails.resourceId), locale, proxy)).then(function (data) {
          var _pageData$doc_meta;
          var pageData = data === null || data === void 0 ? void 0 : data[0];
          var pageName = pageData === null || pageData === void 0 ? void 0 : pageData.page_name;
          var docId = pageData === null || pageData === void 0 || (_pageData$doc_meta = pageData.doc_meta) === null || _pageData$doc_meta === void 0 ? void 0 : _pageData$doc_meta.doc_id;
          if (pageName && docId) {
            setActiveTopicUrl("".concat(docDisplay, "?docId=").concat(docId, "&page=").concat(pageName));
          }
        });
      } else if (urlDetails.docId && urlDetails.page) {
        setActiveTopicUrl("".concat(docDisplay, "?docId=").concat(urlDetails.docId, "&page=").concat(urlDetails.page));
      }
    }
  }, [activeTopicUrls, locale, proxy, viewTopicPrefix]);
  return {
    topics: topics,
    setTopicsId: setTopicsId,
    setActiveTopicId: setActiveTopicId,
    addTopicUrl: addTopicUrl,
    activeTopicContent: activeTopicContent,
    activeTopicUrl: activeTopicUrl,
    activeTopicUrls: activeTopicUrls,
    loading: loading,
    error: error
  };
};